export type OptionButtonType = 'start' | 'home';

interface IProps {
    button: OptionButtonType,
    onUp?(): void;
    onDown?(): void;
}

export const OptionButton: React.FC<IProps> = ({ button, onDown, onUp }) => {
    return (
        <button
            className="h-2.5 w-20 min-w-20 bg-black flex justify-center items-center select-none p-2 pixel-corners shading shading-active"
            onMouseDown={onDown}
            onMouseUp={onUp}
        >
            <p className='text-xs text-green-btn font-pixel-text self-center'>{button.toUpperCase()}</p>
        </button>
    )
}
